export function partialHiddenEmail(text: string) {
	if (text.length === 0) {
		return '';
	}

	const NAME_VISIBLE_CHARACTERS = 2;

	const createHiderMask = (textReference: string, visibleCharacter: number) => {
		const whichLetters = textReference.slice(0, textReference.length - visibleCharacter);

		const mask = whichLetters.replace(/[a-zA-Z0-9]/g, '*');

		return mask;
	};

	const emailAdress = text.split('@');

	const nameEmail = emailAdress[0];

	const secondPart = emailAdress[1].split('.');
	const providerEmail = secondPart[0];

	const dotRegister =
		secondPart[1] +
		(secondPart[2] ? `.${secondPart[2]}` : '') +
		(secondPart[3] ? `.${secondPart[3]}` : '');

	const providerVisibleCharacters = providerEmail.length - 3;

	const beforeAt = `${nameEmail.substring(0, NAME_VISIBLE_CHARACTERS)}${createHiderMask(
		nameEmail,
		NAME_VISIBLE_CHARACTERS,
	)}`;

	const afterAt = `${providerEmail.substring(0, 1)}${createHiderMask(
		providerEmail,
		providerVisibleCharacters,
	)}${providerEmail.substring(providerVisibleCharacters + 1, providerEmail.length)}`;

	return `${beforeAt}@${afterAt}.${dotRegister}`;
}
